<template>
  <div class="app-footer">
          <!-- <img src="../../assets/image/logo1.png" alt="" srcset=""> -->
          <!-- <p style="font-size: 28px;margin-top: 22px;font-weight: 800;">数据管理软件</p> -->
          <!-- <p style="margin-top: 3px;">版本：<span>{{Ver}}</span></p> -->
          <p style="margin-top: 20px;">
            <span>Copyright  ©  上海导向医疗系统有限公司  All Rights Reserved</span>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <el-link :href="link" target="_blank">沪ICP备19046950号-1</el-link>
          </p>
          <p style="margin-top: 20px;padding-bottom:10px;display: flex;flex-direction: row;align-items: center;justify-content: center;">
            <el-link :href="webSearch"><img src="../../assets/image/beian.png" alt=""></el-link>
            <el-link :href="webSearch"style="margin-left: 5px;">沪公网安备 31011502016064号</el-link>
          </p>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        link:'https://beian.miit.gov.cn',
        webSearch:"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016064"
      }
    },
    methods:{
    },
    mounted(){

    }
  }
</script>


<style lang="scss" scoped>
.app-footer {
  height: 100%;
  color: #fff;
  // margin-top: $header-height;

  .el-link{
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/app-footer.vue